export default function SectionIndustry() {
  return (
    <div className="flex flex-col items-center justify-center space-y-8 py-8 md:py-16">
      <div className="md:font-reguler text-center text-xl font-medium text-[#6E7175]">
        Dipercaya oleh berbagai sektor industri di Jepang
      </div>
      {/* <div className="flex w-full justify-center overflow-hidden px-4">
        <img
          className="mt-6 scale-[200%] object-cover md:scale-[100%]"
          src="/img/landing/industri.svg"
        />
      </div> */}
      <div className="flex flex-wrap items-center justify-center gap-6 px-8">
        {TRUST_BY.map((item) => (
          <Industry key={item.name} {...item} />
        ))}
      </div>
    </div>
  )
}

type IndustryProps = {
  name: string
  logo: string
}

function Industry({ name, logo }: IndustryProps) {
  return (
    <div className="flex items-center">
      <img src={logo} className="mr-2 h-7 w-7 select-none md:h-8 md:w-8" />
      <p className="text-xl font-medium md:text-2xl">{name}</p>
    </div>
  )
}

const TRUST_BY = [
  {
    name: 'Manufaktur',
    logo: '/img/landing/trust-by/manufacturing.png',
  },
  {
    name: 'Teknologi',
    logo: '/img/landing/trust-by/technology.png',
  },
  {
    name: 'Farmasi',
    logo: '/img/landing/trust-by/pharmacy.png',
  },
  {
    name: 'Logistik',
    logo: '/img/landing/trust-by/logistics.png',
  },
  {
    name: 'Pertanian',
    logo: '/img/landing/trust-by/agriculture.png',
  },
] satisfies IndustryProps[]
